import {Button, ButtonPriority, HoverStyles} from '@wix/wix-ui-tpa/cssVars'
import classNames from 'classnames'
import React, {PropsWithChildren} from 'react'
import {SecondaryButtonProps} from './interfaces'
import {classes} from './secondary-button.st.css'

export const SecondaryButton = ({
  onClick,
  className,
  dataHook,
  narrowerButton,
  children,
}: PropsWithChildren<SecondaryButtonProps>) => (
  <Button
    upgrade
    priority={ButtonPriority.secondary}
    className={classNames(classes.root, className, {
      [classes.narrowerButton]: narrowerButton,
    })}
    onClick={onClick}
    data-hook={dataHook}
    hoverStyle={HoverStyles.underline}
  >
    {children}
  </Button>
)
